export default [
  {
    path: '/crm/clientes',
    name: 'crm-clientes',
    component: () => import('@/views/crm/CrmClientesList.vue'),
    meta: {
      pageTitle: 'CRM - Clientes',
      action: 'read',
      resource: 'MenuCrmClientes',
      breadcrumb: [
        { text: 'CRM', active: false },
        { text: 'Clientes', active: true },
      ],
    },
  },
  {
    path: '/crm/clientes/:id',
    name: 'crm-cliente-detail',
    component: () => import('@/views/crm/CrmClienteDetail.vue'),
    meta: {
      pageTitle: 'CRM - Detalhe do Cliente',
      action: 'read',
      resource: 'MenuCrmClientes',
      breadcrumb: [
        { text: 'CRM', active: false },
        { text: 'Clientes', to: '/crm/clientes' },
        { text: 'Detalhe', active: true },
      ],
    },
  },
  {
    path: '/crm/agenda',
    name: 'crm-agenda',
    component: () => import('@/views/crm/CrmAgendaPage.vue'),
    meta: {
      pageTitle: 'CRM - Agenda',
      action: 'read',
      resource: 'MenuCrmAgenda',
      breadcrumb: [
        { text: 'CRM', active: false },
        { text: 'Agenda', active: true },
      ],
    },
  },
  {
    path: '/crm/oportunidades',
    name: 'crm-oportunidades',
    component: () => import('@/views/crm/CrmOportunidadesPage.vue'),
    meta: {
      pageTitle: 'CRM - Oportunidades',
      action: 'read',
      resource: 'MenuCrmOportunidades',
      breadcrumb: [
        { text: 'CRM', active: false },
        { text: 'Oportunidades', active: true },
      ],
    },
  },
  {
    path: '/crm/aniversariantes',
    name: 'crm-aniversariantes',
    component: () => import('@/views/crm/CrmAniversariantesPage.vue'),
    meta: {
      pageTitle: 'CRM - Aniversariantes',
      action: 'read',
      resource: 'MenuCrmAniversariantes',
      breadcrumb: [
        { text: 'CRM', active: false },
        { text: 'Aniversariantes', active: true },
      ],
    },
  },
];
